import { inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { UserService } from '@core/services';

export class UseUser {
  private readonly _userService = inject(UserService);
  private readonly _sanitizer = inject(DomSanitizer);

  getUserPhoto(memberId: number) {
    return this._userService.getUserProfilePhoto(memberId).pipe(
      map((blob) => {
        if (blob) {
          const urlCreator: any = window.URL || window.webkitURL;
          return this._sanitizer.bypassSecurityTrustUrl(urlCreator.createObjectURL(blob));
        }
        return null;
      }),
    );
  }

  getUserPhotoFromLocal(memberId: number) {
    return this._userService.getUserProfilePhotoFromLocal(memberId);
  }

  uploadUserProfileImage(imageInBase64: string) {
    return this._userService.uploadUserPhoto({ image_file: imageInBase64 });
  }
}
